import { render, staticRenderFns } from "./medicalHistory.vue?vue&type=template&id=11e1ea56&scoped=true&"
import script from "./medicalHistory.vue?vue&type=script&lang=js&"
export * from "./medicalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e1ea56",
  null
  
)

export default component.exports